import React from 'react'
import PropTypes from 'prop-types'
import {Progress} from 'antd'
import {FileOutlined, CloseOutlined} from '@ant-design/icons'
import Button from 'components/shared/Button'

class FileUpload extends React.Component {
  static propTypes = {
    uploader: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.uploader.startUpload()
  }

  cancelUpload() {
    this.props.onCancel(this.props.uploader)
  }

  render() {
    // Halt progress at 99% untill fully submitted to iweb which will unmount this
    // component anyway.
    const progress = Math.min(this.props.uploader.progress, 99)

    return (
      <div className="file-upload">
        <div className="icon">
          <FileOutlined />
        </div>
        <div className="file-progress">
          <div className="filename">
            {this.props.uploader.inputBlob.name}
          </div>
          <Progress percent={progress} />
        </div>
        <div className="remove">
          <Button
            icon={<CloseOutlined />}
            onClick={this.cancelUpload.bind(this)}
          />
        </div>
      </div>
    )
  }
}

export default FileUpload
